import { useDocumentTitle } from "@uidotdev/usehooks";

import { StandardContent } from "@/components/App";
import Header from "@/components/Header";
import { PageTitle } from "@/constants/pages";
import { usePageEventTracking } from "@/hooks/event-tracking";

export default function ManageAutoRenewPage() {
  usePageEventTracking();
  useDocumentTitle(PageTitle.MANAGE_AUTO_RENEW);

  return (
    <StandardContent>
      <Header className="mb-6">Manage Auto-Renew</Header>
    </StandardContent>
  );
}
